import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Anchor, Zap, Trophy, Timer, Waves, Sunrise } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function SurfskiPage() {
  useEffect(() => {
    // Set meta tags for Surfski page
    document.title = "קיאק Surfski | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'חתירה בקיאק Surfski בכנרת - מהירות, אדרנלין וטכניקה או חתירה רגועה ונופי הכנרת. הדרכות וקבוצות אימון');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין או חתירה רגועה. הדרכות אישיות וקבוצות אימון'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1715" data-mp="2z7m0gvpnlhk3">
      <Navigation data-id="element-1716" data-mp="2z7vr8liivsqu" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-1717" data-mp="2u7zp6rtdybdx">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-1718" data-mp="2u6g84yzwnwb3" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png" alt="Surfski Activity" className="w-full h-full object-cover" data-id="element-1719" data-mp="2q7fpphlcavom" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1720" data-mp="1err3isfwu0ov">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1721" data-mp="3qfnkcgt9mcn7">
            קיאק Surfski
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-1722" data-mp="38llmdxd2i31">
            מהירות, אדרנלין וטכניקה על המים - או סתם חתירה רגועה ונופי הכנרת
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1723" data-mp="m15wkgd3u2ik">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1724" data-mp="qzh58nrny6z7">
          <div data-id="element-1725" data-mp="qxmvm5lue1af">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-1726" data-mp="2ns0upeusadsg">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-1727" data-mp="2squa5ctmsev9">
              ה-Surfski הוא קיאק פתוח, צר וארוך, המיועד לחתירה מהירה ולגלישת
              גלים (Downwind). זהו ספורט המשלב כושר גופני אירובי ברמה גבוהה עם
              מיומנות טכנית של קריאת הים ותפיסת גלים. במועדון שלנו תמצאו את
              הקיאקים הטובים בעולם מבית המותגים המובילים.
            </p>

            {/* Relaxed Paddling Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-2xl p-6 mb-8" data-id="element-1728" data-mp="22fqwor3zcn0a">
              <div className="flex items-start gap-4" data-id="element-1729" data-mp="1ohaoswudsqgk">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-1730" data-mp="1jpix2izhoeou">
                  <Sunrise className="w-6 h-6 text-blue-500" data-id="element-1731" data-mp="1jo7tok9yh8y9" />
                </div>
                <div data-id="element-1732" data-mp="vyn8duqbxzlt">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1733" data-mp="vy3nq69aox43">
                    חתירה רגועה ונופי הכנרת
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-1734" data-mp="32ogqovtv6yb0">
                    לא חייבים להיות ספורטיביים! הקיאק מושלם גם לחתירה רגועה
                    ונינוחה על מי הכנרת השקטים. תיהנו מהשקט, מהנוף המדהים של
                    ההרים מסביב, ומחוויה מדיטטיבית של חיבור לטבע. מתאים במיוחד
                    לזריחות ושקיעות קסומות.
                  </p>
                </div>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1735" data-mp="3lfq5nkmemf9z">
              למי זה מתאים?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-1736" data-mp="3qd9hkdvmqfyr">
              {['חותרים המחפשים אתגר פיזי ומנטלי', 'אוהבי אדרנלין ומהירות', 'מי שרוצה חתירה רגועה ולהנות מנופי הכנרת', 'מי שרק בא לו להרגע ולהתנתק מהשגרה', 'אנשים עם רקע בחתירה (אך לא חובה, יש קורסי מתחילים)', 'מי שרוצה לשפר את הכושר האירובי בצורה משמעותית'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-1737" data-mp="20xa5anwpsaew" data-mpi={i}>
                  <div className="bg-indigo-100 p-1 rounded-full" data-id="element-1738" data-mp="251hwcrqna2ga">
                    <Zap className="w-4 h-4 text-indigo-600" data-id="element-1739" data-mp="bhg3lj7hnlfg" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-1740" data-mp="6kpr15uw77ys">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-1741" data-mp="1qbrcr976eob">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-1742" data-mp="3sw4ttk42op4k">
              <div className="flex gap-4" data-id="element-1743" data-mp="3ox5gpc86tm21">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1744" data-mp="3oy732cunluz2">
                  <Anchor className="w-6 h-6 text-indigo-500" data-id="element-1745" data-mp="3jwhqgsrs998v" />
                </div>
                <div data-id="element-1746" data-mp="3exws6yw3czn2">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1747" data-mp="3ez7sgoqbvp9f">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1748" data-mp="3a1g2i098ud7v">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1749" data-mp="1goz95at3ndnp">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1750" data-mp="1gnxt0rx880z4">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1751" data-mp="1kq2lvofuotkp" />
                </div>
                <div data-id="element-1752" data-mp="1phb0qzzy9759">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1753" data-mp="1ph14iuoba3r4">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1754" data-mp="1ug4conzl8q3b">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1755" data-mp="11rq9lttn73kw">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1756" data-mp="11shyymwnc52q">
                  <Zap className="w-6 h-6 text-indigo-500" data-id="element-1757" data-mp="16qjs60nsdkrx" />
                </div>
                <div data-id="element-1758" data-mp="1bpmngtdyscmp">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1759" data-mp="1bq63g4k20qy3">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1760" data-mp="2i68f4s11ijsq">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1761" data-mp="3893p2aduc7qq">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1762" data-mp="389wwzeojd3ag">
                  <Trophy className="w-6 h-6 text-indigo-500" data-id="element-1763" data-mp="3481uw7ys6lvm" />
                </div>
                <div data-id="element-1764" data-mp="3hyn8bh5gu3m4">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1765" data-mp="3hz6sz5mi363u">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1766" data-mp="3d6ne85c2u4xg">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1767" data-mp="3n049ldrv3s38">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1768" data-mp="4sn3z4og5bnv">
                  <Timer className="w-6 h-6 text-indigo-500" data-id="element-1769" data-mp="3vyogzirz2fc5" />
                </div>
                <div data-id="element-1770" data-mp="3vwvcoa4u077b">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1771" data-mp="26ji5md5c452i">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1772" data-mp="26ll0bahfmmdk">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1773" data-mp="h4yxygjr59gz">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1774" data-mp="m1z6cy42qob9">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1775" data-mp="8akkmjis890i" />
                </div>
                <div data-id="element-1776" data-mp="88hv00ljkhwb">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1777" data-mp="cbe8xe04zptx">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1778" data-mp="3ughl1ioit23u">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-1779" data-mp="3pi67oxz0o9gv">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1780" data-mp="3pkinb4hay7qr">
                הצטרפו לאימון ניסיון
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-1781" data-mp="2yjiwsxhm17vl" />
      <Footer data-id="element-1782" data-mp="2yj0pn5tet98w" />
    </div>;
}